import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import SiteDetailsAHJ from "./SiteDetailsAHJ";
import "./SiteDetailsAHJ.scss";
import "./InspectionPage.scss";
import axios from "axios";
import { getAPIUrl } from "../components/common/helpers";
import { ReactComponent as Logo } from '../icons-svg/icons/Otis_logo_white.svg';
import { ReactComponent as NoRecord } from "../icons-svg/icons/NoRecord.svg";
import Loader from "../components/common/CommonFallBackLoader";
import ErrorBoundary from "../components/common/ErrorBoundary";
import ErrorFallback from "../components/common/ErrorFallback";

const NoRecordContent = () => {
  return (
    <div className="noRecordDiv">
      <NoRecord />
      <p className="noRecordMainText">No matches found</p>
      <p className="noRecordSubText">No records found for the applied filters.</p>
    </div>
  )
}

const PublicPage = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [siteBriefData, setSiteBriefData] = useState([]);

  useEffect(() => {
    const encryptedSiteId = searchParams.get("id");
    if (!encryptedSiteId) {
      setError("Invalid URL");
      setLoading(false);
      return;
    }
    const loadSiteDetails = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await axios.get(getAPIUrl("getAHJdata") + `?id=${encryptedSiteId}`);
        if (response.status === 200) {
          setSiteBriefData(response.data || []);
        } else {
          setError(`Unexpected response: ${response.status}`);
        }
      } catch (err) {
        console.error(err);
        setError(err.message || "Error loading site data");
      } finally {
        setLoading(false);
      }
    };
    loadSiteDetails();
  }, [searchParams]);

  let siteContent;
  if (loading) {
    siteContent = <Loader height="40vh" />;
  }
  else if (error) {
    siteContent = (
      <ErrorFallback />
    );
  }
  else if (siteBriefData.length === 0) {
    siteContent = <NoRecordContent />;
  } else {
    siteContent = (
      <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => window.location.reload()}>
        <SiteDetailsAHJ siteBriefData={siteBriefData} />
      </ErrorBoundary>
    );
  }

  return (
    <div className="app-layout">
      <div className="main-wrapper">
        <div className="OtisFixedHeader">
          <Logo />
        </div>
      </div>
      <div className="main-container">
        {siteContent}
      </div>
    </div>
  );
}

export default PublicPage;
